/* Shopify Banner Slider JavaScript */
class BannerSlider {
    constructor() {
        this.slides = document.querySelectorAll('.slide');
        this.dots = document.querySelectorAll('.nav-dot');
        this.prevBtn = document.getElementById('prevBtn');
        this.nextBtn = document.getElementById('nextBtn');
        this.progressBar = document.getElementById('progressBar');
        this.currentSlide = 0;
        this.totalSlides = this.slides.length;
        this.autoPlayInterval = null;
        this.progressInterval = null;
        this.slideTimer = 5000; // 5 seconds - change this value to adjust timing
        this.progressStep = 100 / (this.slideTimer / 100);
        
        if (this.slides.length > 0) {
            this.init();
        }
    }
    
    init() {
        // Event listeners for arrow buttons
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => this.prevSlide());
        }
        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => this.nextSlide());
        }
        
        // Event listeners for navigation dots
        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.goToSlide(index));
        });
        
        // Pause on hover
        const container = document.querySelector('.banner-container');
        if (container) {
            container.addEventListener('mouseenter', () => this.pauseAutoPlay());
            container.addEventListener('mouseleave', () => this.startAutoPlay());
        }
        
        // Start auto-play and progress
        this.startAutoPlay();
        this.startProgress();
        
        // Handle visibility change (pause when tab is not active)
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                this.pauseAutoPlay();
            } else {
                this.startAutoPlay();
                this.resetProgress();
            }
        });
    }
    
    goToSlide(index) {
        if (index === this.currentSlide) return;
        
        // Remove active class from current slide
        const currentSlideEl = this.slides[this.currentSlide];
        currentSlideEl.classList.add('exiting');
        currentSlideEl.classList.remove('active');
        
        setTimeout(() => {
            currentSlideEl.classList.remove('exiting');
        }, 1200);
        
        // Remove active from current dot
        if (this.dots[this.currentSlide]) {
            this.dots[this.currentSlide].classList.remove('active');
        }
        
        // Update current slide
        this.currentSlide = index;
        
        // Add active to new slide and dot
        this.slides[this.currentSlide].classList.add('active');
        if (this.dots[this.currentSlide]) {
            this.dots[this.currentSlide].classList.add('active');
        }
        
        // Reset progress
        this.resetProgress();
    }
    
    nextSlide() {
        const nextIndex = (this.currentSlide + 1) % this.totalSlides;
        this.goToSlide(nextIndex);
    }
    
    prevSlide() {
        const prevIndex = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
        this.goToSlide(prevIndex);
    }
    
    startAutoPlay() {
        this.autoPlayInterval = setInterval(() => {
            this.nextSlide();
        }, this.slideTimer);
    }
    
    pauseAutoPlay() {
        if (this.autoPlayInterval) {
            clearInterval(this.autoPlayInterval);
        }
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
        }
    }
    
    startProgress() {
        let progress = 0;
        if (this.progressBar) {
            this.progressBar.style.width = '0%';
        }
        
        this.progressInterval = setInterval(() => {
            progress += this.progressStep;
            if (this.progressBar) {
                this.progressBar.style.width = progress + '%';
            }
            
            if (progress >= 100) {
                progress = 0;
            }
        }, 100);
    }
    
    resetProgress() {
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
        }
        if (this.progressBar) {
            this.progressBar.style.width = '0%';
        }
        this.startProgress();
        
        if (this.autoPlayInterval) {
            clearInterval(this.autoPlayInterval);
        }
        this.startAutoPlay();
    }
}

// Initialize slider when DOM is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new BannerSlider();
    });
} else {
    // DOM is already loaded
    new BannerSlider();
}

// Also initialize on Shopify's theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
        new BannerSlider();
    });
    
    document.addEventListener('shopify:section:reorder', () => {
        new BannerSlider();
    });
}